export class ResultPagDTO<T> {
  pageNumber: Number;
  pageSize: Number;
  totalElements: Number;
  content: Array<T>;
}

export class BaseFiltroPagDTO {
  page: Number = 1;
  size: Number = 25;
  sortProperties: string;
  direction: "ASC" | "DESC" = "ASC";

  update(pagination: PaginationSyncDTO) {
    this.page = pagination.page;
    this.size = pagination.rowsPerPage;
    this.sortProperties = pagination.sortBy ? pagination.sortBy : null;
    this.direction = pagination.descending ? "DESC" : "ASC";
  }
}

// Para auxiliar DataTables Pagination
// https://v15.vuetifyjs.com/pt-BR/components/data-tables
export class PaginationSyncDTO {
  descending: boolean = false;
  page: Number = 1;
  rowsPerPage: Number = 25; // -1 for All"
  sortBy: string;
  totalItems: Number;
  rowsPerPageItems: Number[] = [10, 25, 50, 100];

  constructor(sortBy: string = null) {
    this.sortBy = sortBy;
  }

  static update(pagination: PaginationSyncDTO, result: ResultPagDTO<any>) {
    pagination.totalItems = result.totalElements;
  }

  static updateSortProperties(pagination: PaginationSyncDTO, filter: BaseFiltroPagDTO) {
    if (!pagination || !filter || !filter.sortProperties) {
      return;
    }
    pagination.descending = filter.direction == "DESC";
    pagination.sortBy = filter.sortProperties;
  }
}

export class IdNomeDTO {
  id: string;
  nome: string;
}

export class IdNumNomeDTO {
  id: number;
  nome: string;
}

export class IdNomeDescDTO {
  id: string;
  nome: string;
  descricao: string;
}

export class TipoArquivoDTO extends IdNomeDTO {
  extensoes: string[];
  descExtensoes: string;
  tamanhoMaxMb: number;
  descTamMax: string;
}

export class IdCodNomeDTO {
  id: string;
  codigo: string;
  nome: string;
}

export class JsonException {
  className: string;
}

export class BaseLogDTO {
  usuarioInclusao: string;
  dataInclusao: Date;
  usuarioAlteracao: string;
  dataAlteracao: Date;
}

export class IdNomeObsListDTO {
  lista: IdNomeDTO[];
  observacao: string;
}

export class ArquivoWebDTO {
  id: number;
  url: string;
}
